<template>
  <v-autocomplete
    outlined
    filled
    dense
    height="44"
    hide-details
    :value="corporationId"
    item-text="name"
    item-value="id"
    class="bs-search-item"
    background-color="#ffffff"
    :placeholder="$t('components.corporationSelect.selectCorporation')"
    :items="corporations"
    @update:search-input="searchAccounts"
    @change="onChangeAccount"
  >
    <template v-slot:prepend-inner>
      <department-icon/>
    </template>
    <template v-slot:append>
      <v-icon>mdi-chevron-down</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.name" />
        <v-list-item-subtitle v-text="item.id" />
      </v-list-item-content>
    </template>
    <template v-slot:append-item>
      <div v-if="isShowIntersection" class="intersection-wrapper d-flex justify-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-intersect.quiet="endIntersect"
        ></v-progress-circular>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconLoader } from '@/helpers/iconsLoader';

const defaultState = {
  page: 0,
  maxPerPage: 10,
  sort: 'name',
};

export default {
  name: "AccountSelectField",
  components: {
    ...iconLoader.sideMenu,
  },
  props: {
    corporationId: {
      type: String,
    },
  },
  data: () => ({
    corporations: [],
    activeAccoutId: null,
    accountSearch: '',
    isShowIntersection: true,
  }),
  mounted() {
    this.corporations = this.getCorporationsList
  },
  computed: {
    ...mapGetters('corporations', ['getSelectedCorporationId', 'getCorporationsList']),
    accountSearchInExistingList() {
      if (!this.accountSearch) {
        return [];
      }

      return this.corporations.filter((account) => account.name.toLowerCase().includes(this.accountSearch.toLowerCase()));
    }
  },
  methods: {
    async searchAccounts(search) {
      this.accountSearch = search;

      if (search && search.length < 3 || this.accountSearchInExistingList.length) {
        this.corporations = this.getCorporationsList
        return;
      }
      
      const { data } = await this.$store.dispatch('corporations/listCorporations', {
        ...defaultState,
        name: search,
      });

      this.corporations = data
    },
    async loadMoreCorporations() {
      this.corporations = this.getCorporationsList;

      const { data } = await this.$store.dispatch('corporations/listCorporations', {
        ...defaultState,
        page: defaultState.page++,
      });

      if (data.length === 0) {
        defaultState.page = 0;
        this.isShowIntersection = false;
      }

      this.corporations = [...this.corporations, ...data];
    },
    onChangeAccount(accountId) {
      const account = this.corporations.find((account) => account.id === accountId);
      this.$emit('change', account.id);
    },
    endIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.loadMoreCorporations();
      }
    },
  },
}
</script>